












































































































































































import {
  Mixins, Component, Ref,
} from 'vue-property-decorator';
import MultipleLevelSelect from '@/MultipleLevelSelect';
import Editor from '@/Editor';
import {
  getRequireDetail, addRequire, updateRequire, getEnterpriseDetail,
} from 'service/api';
import { RequireDetailRes } from 'src/types/views/require';
import InitLocation from 'src/mixin/initLocation';
import { TypeItem } from 'src/types/views/common';
import { ElForm } from 'element-ui/types/form.d';

export type TypeList = {id: string; name: string; children: TypeItem[]}[]

const type: TypeList = [];

const industry: TypeList = [];

@Component({
  components: { MultipleLevelSelect, Editor },
})
export default class Request extends Mixins(InitLocation) {
  @Ref('form') readonly form!: ElForm;

  @Ref('editor') readonly editor!: Editor;

  userInput = {
    title: '',
    sameCity: '0',
    endTime: '',
    type,
    industry,
    price: 0,
    bargaining: '1',
    name: '',
    phone: '',
    isOpen: '0',
    content: '',
    province: '',
    city: '',
    downtown: '',
  };

  enterpriseLocation = {
    province: '',
    city: '',
    downtown: '',
  };

  hasGarden = false;

  loading = false;

  id = '';

  rules = {
    title: [{ required: true, message: '请输入需求标题', trigger: 'blur' }],
    endTime: [{ required: true, message: '请选择截止日期', trigger: 'blur' }],
  }

  modalVisible = false;

  onSameCityChange(val: string) {
    if (val === '0') {
      this.province = '';
      this.city = '';
      this.downtown = '';
      this.cityList = [];
      this.downtownList = [];
    } else {
      this.province = this.enterpriseLocation.province;
      this.city = this.enterpriseLocation.city;
      this.downtown = this.enterpriseLocation.downtown;
      this.initLocation();
    }
  }

  back() {
    this.$store.commit('SET_REFRESH', true);
    this.$router.push({ name: 'myRequire' });
  }

  doSubmit() {
    this.loading = true;
    this.form.validate(async (valid: boolean) => {
      if (valid) {
        const data = this.userInput;
        const param = {
          name: data.title,
          sameCity: data.sameCity,
          endTime: data.endTime,
          province: data.province,
          city: data.city,
          downtown: data.downtown,
          requiredonetype: '',
          requiredtwotype: '',
          requiredoneindustry: '',
          requiredtwoindustry: '',
          price: data.price,
          bargaining: data.bargaining,
          contacts: data.name,
          telephone: data.phone,
          openness: data.isOpen,
          description: data.content,
          id: this.id || 0,
        };
        const [inputType] = data.type;
        if (inputType) {
          param.requiredonetype = inputType.id;
          if (inputType.children && inputType.children.length !== 0) {
            param.requiredtwotype = inputType.children[0].id;
          }
        }
        const [inputIndustry] = data.industry;
        if (inputIndustry) {
          param.requiredoneindustry = inputIndustry.id;
          if (inputIndustry.children && inputIndustry.children.length !== 0) {
            param.requiredtwoindustry = inputIndustry.children[0].id;
          }
        }
        try {
          const service = this.id ? updateRequire : addRequire;
          const res = await service(param);
          if ((res as { state: boolean}).state) {
            this.modalVisible = true;
          } else {
            this.$notify.error((res as { message: string}).message);
          }
        } finally {
          this.loading = false;
        }
      } else {
        this.loading = false;
      }
    });
  }

  toUpdate() {
    this.$confirm('企业才能发布需求，请先升级为企业', '权限不够', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      this.$router.push({ name: 'enterpriseInfo' });
    });
  }

  async getEnterpriseLocation() {
    if (this.$store.state.user.enterpriseId) {
      const res: any = await getEnterpriseDetail();
      if (res.state) {
        this.enterpriseLocation = {
          province: String(res.data.province),
          city: String(res.data.city),
          downtown: String(res.data.downtown),
        };
      }
    } else {
      this.toUpdate();
    }
  }

  async getDetail(id: string) {
    const res = await getRequireDetail({ id });
    const { data: { rows: data } } = (res as RequireDetailRes);
    const inputData = {
      title: data.name,
      sameCity: String(data.sameCity),
      endTime: data.endTime,
      price: data.price,
      bargaining: String(data.bargaining),
      name: data.contacts || '',
      phone: data.telephone || '',
      isOpen: String(data.openness),
      content: data.description || '',
      province: data.province !== '-1' ? data.province : '',
      city: data.city !== '-1' ? data.city : '',
      downtown: data.downtown !== '-1' ? data.downtown : '',
      type: ([] as TypeList),
      industry: ([] as TypeList),
    };
    const detailType: TypeList = [];
    if (data.requiredonetype !== '-1') {
      detailType.push({
        id: data.requiredonetype,
        name: data.requiredtypename.replace(/（.*）/, ''),
        children: [],
      });
      if (data.requiredtwotype !== '-1') {
        const typeArr = data.requiredtypename.match(/（(.*)）/);
        if (typeArr) {
          detailType[0].children.push({
            id: data.requiredtwotype,
            name: typeArr[1],
          });
        }
      }
    }
    const detailIndustry: TypeList = [];
    if (data.requiredoneindustry !== '-1') {
      detailIndustry.push({
        id: data.requiredoneindustry,
        name: data.requiredindustryname.replace(/（.*）/, ''),
        children: [],
      });
      if (data.requiredtwoindustry !== '-1') {
        const industryArr = data.requiredindustryname.match(/（(.*)）/);
        if (industryArr) {
          detailIndustry[0].children.push({
            id: data.requiredtwoindustry,
            name: industryArr[1],
          });
        }
      }
    }
    inputData.type = detailType;
    inputData.industry = detailIndustry;
    this.userInput = inputData;
    (this.editor as any).refresh(inputData.content);
    this.initLocation();
  }

  get province() {
    return this.userInput.province;
  }

  set province(val) {
    this.userInput.province = val;
    if (val !== this.enterpriseLocation.province) {
      this.userInput.sameCity = '0';
    }
  }

  get city() {
    return this.userInput.city;
  }

  set city(val) {
    this.userInput.city = val;
    if (val !== this.enterpriseLocation.city) {
      this.userInput.sameCity = '0';
    }
  }

  get downtown() {
    return this.userInput.downtown;
  }

  set downtown(val) {
    this.userInput.downtown = val;
    if (val !== this.enterpriseLocation.downtown) {
      this.userInput.sameCity = '0';
    } else {
      this.userInput.sameCity = '1';
    }
  }

  mounted() {
    const { id } = this.$route.query;
    if (id) {
      this.getDetail(id as string);
      this.id = (id as string);
    } else {
      this.initLocation();
    }
    this.getEnterpriseLocation();
  }
}
